export default {
    turn : {
        account: "Akun Member",
        count: "Undian",
        history: "Rekor Hadiah",
        time: "Waktu",
        EventsTime: "Waktu Acara ",
        EventsActivities: "Aktifitas",
        to: "Ke",
        prize: "Hadiah",
        status: "Status",
        unpay:  "Belum Klaim",
        payed:  "Diklaim",
        accountError: " Akun Error",
        contact: " Silahkan Menghubungi Customer Service",
        zero: "Waktu pengundian adalah 0",
        drawing: "Hasil Imbang...",
        congratulations: "Selamat:  Hadiah",
        activityEnds: 'Untuk Acara Sudah Selesai',
        EndlookIt: 'Nantikan acara selanjutnya',
        activityStart: 'Acara akan dimulai ',
        EventsNotStart: 'Acara ini belum dimulai',
        UnderConstruction: 'Kegiatan yang sedang dibangun',
        StartlookIt: 'Pantau terus',
        EventsisEnd: 'Acara Ini Telah Berakhir',
        ThanksJoin: 'Terimakasih atas Partisipasi anda！',
        AccountError: 'Akun Error',
        DataError: 'Kesalahan Data',
        TokenError: 'Kesalahan Token',
        drawCountEmpty: 'Hasil imbang tidak cukup'

    },
    awards: {
        "0": "1st",
        "1": "2nd",
        "2": "3rd",
        "3": "4th",
        "4": "5th",
        "5": "6th",
        "6": "7th",
        "7": "8th",
        "8": "9th",
        "9": "10th"
    },
    login: {
        title: 'Lucky Draw Station',
        logIn: 'Sign in',
        account: 'Account',
        password: 'Password'
    },

    navbar: {
        switchLang: "Language",
        home: 'Home',
        profile: 'Profile',
        logOut: 'Log Out',
        message: {
            hello: 'Hi, {msg}'
        }
    },

    level: {
        levelId:  "No. Pool",
        totalBet: "Total Rolloer"
    },
    award: {
        awards: "No. Prize",
        rate:   "Winning Odds",
        level:  "Pool "
    },
    awardLimit: {
        award:     "No. Prize",
        remaining: "Remain Prizes",
        limit:     "Total Prize",
        unlimit:   "Unlimited"
    },
    userInfo: {
        all:        "Semua",
        platform:   "Platform",
        account:    "Akun Member",
        count:      "Sisa Putaran",
        totalCount: "Total Putaran",
        totalBet:   "Jumlah Roller",
        level:      "Kolam "
    },
    winningRecord: {
        all:          "Semua",
        account:      "Akun Member",
        winningTime:  "Waktu",
        platform:     "Platform",
        award:        "No. Prize",
        status:       "Status",
        action:       "Operate",
        unpay:        "Not Yet Claim",
        payed:        "Claimed",
        pay:          "Claim",
        previousPage: "Previous Page",
        nextPage: "Next Page",
        page: "Page {page}",
    },

    button: {
        search: "Pencarian"

    },

    status: {
        update: {
            success: "Perbarui Berhasil",
            error: "Perbarui Gagal",
        }
    },

   router: {
        level: "Rollover Setting",
        award: "No. Prize",
        awardLimit: "Prizes",
        userInfo: "Winner Record",
        winningRecord: "Prizes Record",
        dashboard: "Home"
    },

    //擴充自定義原element-ui的設定名稱
    elementUI: {
        datepicker: {
            rangeSeparator: "Ke",
            startMonth: "Mulai Bulan",
            endMonth: "Akhir Bulan",
        },
        confirm :{
            check: "Apakah anda Yakin ingin Claim?",
            tips: "Hint",
            confirm: "Konfirmasi",
            cancel: "Membatalkan",
            canceled: "Dibatalkan",
        }
    },

    validator: {
        required: "Diperlukan",
    },
}



// WEBPACK FOOTER //
// ./src/lang/id.js